module.exports = __webpack_public_path__ + "img/vino.53776c32.svg";